import script from "./resetPassword.vue?vue&type=script&lang=ts&setup=true"
export * from "./resetPassword.vue?vue&type=script&lang=ts&setup=true"

import "./resetPassword.vue?vue&type=style&index=0&id=5fdc3f38&lang=scss&scoped=true"

import exportComponent from "E:\\workProject\\App.Live.Department.PC\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fdc3f38"]])

export default __exports__